const HistoryDisplay = function(settings) {
	"use strict";

	const _self = this;
	const _settings = {
		currentId: null,
		animating: false,
		deactivating: false
	};

	Object.assign(_settings, settings);

	function cacheDom() {
		_settings.$sections = _settings.$el.querySelectorAll(
			"[" + _settings.anchorDataName + "]"
		);
		_settings.$bigYear = _settings.$el.querySelector(_settings.bigYear);

		_settings.$sections.forEach((el) => {
			var year = document.createElement("span");
			year.classList.add(_settings.bigYearContainerClass);

			var number = el.dataset.stage + "";
			for (var i = 0; i < number.length; i++) {
				let digit = document.createElement("span");
				digit.appendChild(document.createTextNode(number[i]));
				year.appendChild(digit);
			}
			_settings.$bigYear.appendChild(year);
		});

		_settings.$years = _settings.$bigYear.querySelectorAll(
			"." + _settings.bigYearContainerClass
		);
	}

	function bindEvents() {
		window.addEventListener("scroll", handleScroll);
	}

	function handleScroll() {
		if (_settings.animating) return false;

		_settings.animating = true;

		let activeId = 0;
		let i = 0;
		_settings.$sections.forEach((el) => {
			const rect = el.getBoundingClientRect();

			if (rect.top - 50 <= 0) {
				activeId = i + 1;
			}
			i++;
		});

		const active = _settings.$el.querySelectorAll(
			"." + _settings.bigYearContainerActiveClass
		);
		if (active !== null) {
			active.forEach((el) => {
				el.classList.remove(_settings.bigYearContainerActiveClass);
			});
		}

		if (_settings.$years[activeId] !== undefined) {
			_settings.$years[activeId].classList.add(
				_settings.bigYearContainerActiveClass
			);
		} else {
			_settings.$years[_settings.$years.length - 1].classList.add(
				_settings.bigYearContainerActiveClass
			);
		}

		deactivateDisplay();

		_settings.currentId = activeId;

		setTimeout(function() {
			_settings.animating = false;
			handleScroll();
		}, 1200);
	}

	function deactivateDisplay() {
		if (!_settings.currentId || !_settings.deactivating) {
			if (_settings.$years[_settings.currentId] !== undefined) {
				_settings.deactivating = true;

				_settings.$years[_settings.currentId].classList.add(
					_settings.bigYearContainerDeactivatedClass
				);

				let lastElement = _settings.$years[
					_settings.currentId
				].querySelector("span:last-child");

				lastElement.addEventListener("animationend", () => {
					let deactivate = _settings.$el.querySelector(
						"." + _settings.bigYearContainerDeactivatedClass
					);
					if (deactivate !== null) {
						deactivate.classList.remove(
							_settings.bigYearContainerDeactivatedClass
						);
					}
					_settings.deactivating = false;
				});
			}
		}
	}

	function init() {
		cacheDom();
		bindEvents();

		handleScroll();

		return _self;
	}

	return init();
};

export { HistoryDisplay };
